import { NotifyMeType } from '@/@types/client-api';
import {
  NOTIFY_PANEL_GRACEFUL_TRANSITION_SOURCE,
  NOTIFY_PANEL_SALESFORCE_SOURCE
} from './constants';

export const NOTIFY_ME_TYPES = {
  studioBriefing: NotifyMeType._0,
  onDemand: NotifyMeType._1
} as const;

export const getNotifyMeType = (isLiveProgram: boolean, source?: string | null): NotifyMeType =>
  isLiveProgram || source === NOTIFY_PANEL_GRACEFUL_TRANSITION_SOURCE
    ? NOTIFY_ME_TYPES.onDemand
    : NOTIFY_ME_TYPES.studioBriefing;

export const isNativeNotifyMeSource = (source?: string | null) =>
  source === NOTIFY_PANEL_SALESFORCE_SOURCE || source === NOTIFY_PANEL_GRACEFUL_TRANSITION_SOURCE;
